import styled from '@emotion/styled'

import ColumnTrack from '@segment/matcha/components/ColumnTrack'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

import WheneverImage from './WheneverImage'

const copy = {
  title: `Whenever, wherever, your data belongs together`,
  elements: [
    {
      title: `All of your customer data, all in one place`,
      description: `With 450+ pre-built connectors and Reverse ETL, Twilio Segment makes it easy to get data into unified customer profiles to power all the tools you use, fast.`,
      ctaUrl: `/catalog/`,
      ctaText: `Integrate your entire tech stack`,
    },
    {
      title: `Data from your warehouse—real-time, real-fast`,
      description: `Prepare, enrich, and activate existing data in your data warehouse, so every team in your organization can quickly create impactful experiences using rich, real-time data.`,
      ctaUrl: `/product/reverse-etl/`,
      ctaText: `Learn about Reverse ETL`,
    },
    {
      title: `Quality, controlled`,
      description: `Take control of your data quality with intuitive data cleaning features and real-time validation built for enterprise scale.`,
      ctaUrl: `/product/protocols/`,
      ctaText: `Protect your data quality`,
    },
  ],
}

const Whatever = () => {
  const pageConfig = usePageConfig()

  return (
    <Wrapper>
      <StyledSectionBaseTitle variant="noCopy">
        <Section.Contents>
          <CopyTextBase centered={true}>
            <CopyText.Heading tag="h2">{copy.title}</CopyText.Heading>
          </CopyTextBase>
        </Section.Contents>
      </StyledSectionBaseTitle>
      <StyledSectionBaseContent variant="2Col">
        <Section.Contents>
          <WheneverImage />
        </Section.Contents>
        <Section.Copy alignSelf="center">
          <ColumnTrack>
            {copy.elements.map(({ title, description, ctaText, ctaUrl }, key) => (
              <CopyTextBase key={key}>
                <CopyText.Heading tag="h3" variant="pLargeBold">
                  {title}
                </CopyText.Heading>
                <CopyText.Description tag="p" variant="pMedium">
                  {description}
                </CopyText.Description>
                <CopyText.Link href={getAbsoluteUrl(ctaUrl, pageConfig)}>{ctaText}</CopyText.Link>
              </CopyTextBase>
            ))}
          </ColumnTrack>
        </Section.Copy>
      </StyledSectionBaseContent>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  background: ${({ theme }) => theme.palette.twilio.mint[10]};
`

const StyledSectionBaseContent = styled(SectionBase)`
  ${Section.Wrapper} {
    padding-top: 30px;
    padding-bottom: 50px;
  }
`

const StyledSectionBaseTitle = styled(SectionBase)`
  ${Section.Wrapper} {
    padding-top: 50px;
    padding-bottom: 0;
  }
`
export default Whatever
